import { useEffect } from "react";
import { useRecoilValue } from "recoil";
import { sendCodeToViewer } from "../lib/messageBus";
import { HostId } from "../state/atoms";
import { WaitForInitialAsyncCalls } from "../state/selectors";
import { ComposedStack } from "../state/stackSelectors";
import { InPresentationMode } from "../state/uiAtoms";

function SendStackToViewer() {
	// Stack doesn't update on every keystroke whereas CodeSelector does.
	const stack = useRecoilValue(ComposedStack);
	const authorIsReady = useRecoilValue(WaitForInitialAsyncCalls);
	const hostId = useRecoilValue(HostId);
	const isInPresenterMode = useRecoilValue(InPresentationMode);

	useEffect(() => {
		if (isInPresenterMode) return;
		sendCodeToViewer(hostId, stack);
	}, [stack, authorIsReady, hostId]);

	return <></>;
}

export default SendStackToViewer;
